import React from "react";
import "./carousellogo.scss";
import images from "./carousellogo.js";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const carousellogo = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768, // Adjust breakpoint for your mobile size
        settings: {
          slidesToShow: 1, // Show only 1 slide on mobile screens
        },
      },
    ],
  };
  return (
    <div className="container-carousellogo">
      <div className="carousellogo">
        <Slider {...settings}>
          {images.map((image, index) => (
            <div className="parent">
              <img
                className="image-logo"
                key={index}
                src={image}
                alt="foto logo"
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default carousellogo;
